import React from 'react';
import PropTypes from 'prop-types';

import { getLTEUpgrade } from '../../../Helpers/index';
import CommonSection from './commonSection';

const RemainingBalance = ({ remainingBalanceTitle, ltePlans }) => {
  const buyOutAmount = getLTEUpgrade() && ltePlans && ltePlans.buyOutAmount ? ltePlans.buyOutAmount : '';
  const isLteBuyOutAmount = getLTEUpgrade() && buyOutAmount !== '';
  if (!isLteBuyOutAmount) {
    return null;
  }

  return <CommonSection leftValueText={remainingBalanceTitle} rightValueText={`$${buyOutAmount}`} id="RemainingBalance Info" />;
};

RemainingBalance.propTypes = {
  remainingBalanceTitle: PropTypes.string,
  ltePlans: PropTypes.object,
};

export default RemainingBalance;
